import { spacingDecomposeMap } from './decomposer';
import { spacingComposeMap } from './composer';

export const spacing = {
  decomposeMap: spacingDecomposeMap,
  composeMap: spacingComposeMap,
};
